var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"loading-page"},[_c('div',{staticClass:"loading"},[_c('p',[_vm._v("Loading...")]),_vm._v(" "),_c('v-progress-circular',{attrs:{"size":130,"width":2,"color":"#fff","indeterminate":""}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }